$('.owl-carousel.hero-slides').owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    dots: true,
    autoplay: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})
$('.owl-carousel.testimonial-slider').owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    dots: true,
    autoplay: true,
    autoplaySpeed:1500,
    pauseOnHover : true,
    autoplaySpeed: 2000,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
});
$('.owl-carousel.blog-hero-slides').owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    dots: true,
    autoplay: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

function openNav() {
    $("#mobile-nav-menu").animate({
        width: "toggle"
    }).css('display','block');
}

function toggleSubNav(id) {
    var el = document.getElementById("submenu-" + id);
    if (typeof id !== 'undefined') {
        if (el.style.display === 'none')
            $("#submenu-" + id).slideToggle('slow').show();
        else
            $("#submenu-" + id).slideToggle('slow');
    }
}

function openCart() {
    document.getElementById("cart-container").style.display = "block";
    document.querySelector('body').style.overflow = "hidden";
}

function openSearch() {
    document.getElementById("search-container").style.display = "block";
}

function closeNav() {
    $("#mobile-nav-menu").animate({
        width: "toggle"
    }).css('display','block');
}

function closeCart() {
    document.getElementById("cart-container").style.display = "none";
    document.querySelector('body').style.overflow = "visible";
}

function closeSearch() {
    document.getElementById("search-container").style.display = "none";
}

window.onscroll = function () {
    myFunction()
};

var header = document.getElementById("navbar");
var sticky = header.offsetTop;

function myFunction() {
    if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
    } else {
        header.classList.remove("sticky");
    }
}

var acc = document.getElementsByClassName("accordion");
var i;

$(document).ready(function () {
    $('.minus').click(function () {
        var $input = $(this).parent().find('input');
        var count = parseInt($input.val()) - 1;
        count = count < 1 ? 1 : count;
        $input.val(count);
        $input.change();
        return false;
    });
    $('.plus').click(function () {
        var $input = $(this).parent().find('input');
        $input.val(parseInt($input.val()) + 1);
        $input.change();
        return false;
    });
});

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
    });
}

$(document).ready(function () {

    // Sliders

    //// Slider Top
    $('.js-items-slider-container .slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.js-items-slider-container .slider-nav'
    });
    $('.js-items-slider-container .slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.js-items-slider-container .slider-for',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: false,
        accessibility: true,
        onAfterChange: function (slide, index) {
            console.log("slider-nav change");
            console.log(this.$slides.get(index));
            $('.current-slide').removeClass('current-slide');
            $(this.$slides.get(index)).addClass('current-slide');
        },
        onInit: function (slick) {
            $(slick.$slides.get(0)).addClass('current-slide');
        }
    });
});


